module.exports = __webpack_public_path__ + "img/Gehölz.52509908.jpg";